import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { ProtectedSuperAdminRoute } from '../auth/ProtectedSuperAdminRoute';
import { CoreLayout } from '../layout/CoreLayout';
import { LoginPage } from '../pages/LoginPage';

import { DashboardPage } from '../../features/dashboard';
import {
  TenantsPage,
  TenantWorkspacePage,
} from '../../features/tenants';
import {
  UsersPage,
  UserWorkspacePage,
} from '../../features/users';
import {
  ServicesPage,
  ServiceWorkspacePage,
} from '../../features/services';
import {
  OrdersPage,
  OrderWorkspacePage,
} from '../../features/orders';
import {
  WalletPage,
  WalletWorkspacePage,
} from '../../features/wallet';
import {
  CommissionPage,
  CommissionWorkspacePage,
} from '../../features/commission';
import {
  MonitoringPage,
  MonitoringWorkspacePage,
} from '../../features/monitoring';
import {
  SecurityPage,
  SecurityWorkspacePage,
} from '../../features/security';
import {
  AuditPage,
  AuditWorkspacePage,
} from '../../features/audit';
import {
  AnalyticsPage,
  AnalyticsWorkspacePage,
} from '../../features/analytics';
import {
  PermissionsPage,
  PermissionWorkspacePage,
} from '../../features/permissions';
import {
  SettingsPage,
  SettingsWorkspacePage,
} from '../../features/settings';
import { ControlPlaneReferencePreviewPage } from '../components/foundation/control-plane/reference/ControlPlaneReferencePreviewPage';

function CustomerCompatibilityRedirect() {
  const { id } = useParams<{ id: string }>();

  return <Navigate to={`/users/${id}?view=customers`} replace />;
}

export function AppRouter() {
  return (
    <Routes>
      <Route
        path="/login"
        element={<LoginPage />}
      />

      <Route
        element={
          <ProtectedSuperAdminRoute>
            <CoreLayout />
          </ProtectedSuperAdminRoute>
        }
      >
        {import.meta.env.DEV ? <Route path="__preview/control-plane-reference" element={<ControlPlaneReferencePreviewPage />} /> : null}
        <Route
          index
          element={
            <Navigate
              to="/dashboard"
              replace
            />
          }
        />

        <Route
          path="dashboard"
          element={<DashboardPage />}
        />

        <Route
          path="tenants"
          element={<TenantsPage />}
        />
        <Route
          path="tenants/:id"
          element={<TenantWorkspacePage />}
        />

        <Route
          path="users"
          element={<UsersPage />}
        />
        <Route
          path="users/:id"
          element={<UserWorkspacePage />}
        />

        <Route
          path="customers"
          element={<Navigate to="/users?view=customers" replace />}
        />
        <Route
          path="customers/:id"
          element={<CustomerCompatibilityRedirect />}
        />

        <Route
          path="services"
          element={<ServicesPage />}
        />
        <Route
          path="services/:id"
          element={<ServiceWorkspacePage />}
        />

        <Route
          path="orders"
          element={<OrdersPage />}
        />
        <Route
          path="orders/:id"
          element={<OrderWorkspacePage />}
        />

        <Route
          path="wallet"
          element={<WalletPage />}
        />
        <Route
          path="wallet/:id"
          element={<WalletWorkspacePage />}
        />

        <Route
          path="commission"
          element={<CommissionPage />}
        />
        <Route
          path="commission/:id"
          element={<CommissionWorkspacePage />}
        />

        <Route
          path="monitoring"
          element={<MonitoringPage />}
        />
        <Route
          path="monitoring/:id"
          element={<MonitoringWorkspacePage />}
        />

        <Route
          path="security"
          element={<SecurityPage />}
        />
        <Route
          path="security/:id"
          element={<SecurityWorkspacePage />}
        />

        <Route
          path="audit"
          element={<AuditPage />}
        />
        <Route
          path="audit/:id"
          element={<AuditWorkspacePage />}
        />

        <Route
          path="analytics"
          element={<AnalyticsPage />}
        />
        <Route
          path="analytics/:id"
          element={<AnalyticsWorkspacePage />}
        />

        <Route
          path="permissions"
          element={<PermissionsPage />}
        />
        <Route
          path="permissions/:id"
          element={<PermissionWorkspacePage />}
        />

        <Route
          path="settings"
          element={<SettingsPage />}
        />
        <Route
          path="settings/:id"
          element={<SettingsWorkspacePage />}
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/dashboard"
              replace
            />
          }
        />
      </Route>
    </Routes>
  );
}
